import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

/**
 * PasswordRecoveryService - Servicio especializado para recuperación de contraseña
 * Responsabilidad única: Gestionar el proceso de recuperación y reseteo de contraseña
 */
@Injectable({
  providedIn: 'root',
})
export class PasswordRecoveryService {
  private apiUrlEmail = `${environment.apiURL}password/send-reset-link`;
  private apiUrlResetPassword = `${environment.apiURL}password/reset`;

  constructor(private http: HttpClient) { }

  /**
   * Envía un enlace de recuperación de contraseña al email especificado
   * @param email Email del usuario que solicita recuperar contraseña
   * @returns Observable con la respuesta del servidor
   */
  sendResetLink(email: string): Observable<PasswordResetLinkResponse> {
    return this.http.post<PasswordResetLinkResponse>(this.apiUrlEmail, { email });
  }

  /**
   * Resetea la contraseña del usuario usando el token recibido por email
   * @param data Datos necesarios para resetear la contraseña
   * @returns Observable con la respuesta del servidor
   */
  resetPassword(data: PasswordResetData): Observable<PasswordResetResponse> {
    return this.http.post<PasswordResetResponse>(this.apiUrlResetPassword, data);
  }
}

/**
 * Interface para los datos de reseteo de contraseña
 */
export interface PasswordResetData {
  token: string | null;
  email: string | null;
  password: string;
  password_confirmation: string;
}

/**
 * Interface para la respuesta del envío de enlace de reseteo
 */
export interface PasswordResetLinkResponse {
  message: string;
  [key: string]: any;
}

/**
 * Interface para la respuesta del reseteo de contraseña
 */
export interface PasswordResetResponse {
  message: string;
  [key: string]: any;
}
